import {HotMatchReducer, ReducerFromState} from "../../../@types/reducers";
import {HotMatchSettingsObject} from "../../../@types/response";

export const getSettings = (state: ReducerFromState<HotMatchReducer>): HotMatchSettingsObject => state.hotMatch.settings;